import { MARQUEE } from '../constants/testIds';

const ITEMS = [
  '100% PRESSURE TESTED', 'GRADE A 7MM+', 'GRADE B 5–6.5MM', 'TRUCK & PASSENGER RADIALS',
  '800 / 1600 / 2400 TIRE TIERS', 'GLOBAL DISTRIBUTION NETWORK', 'FAST FREIGHT DISPATCH',
  'EXPORT-READY TRIPLE PACKAGING',
];

export const Marquee = () => (
  <div data-testid={MARQUEE.ticker} className="relative bg-brand-amber text-brand-bg py-3.5 overflow-hidden border-y border-brand-bg/10">
    <div className="flex whitespace-nowrap animate-marquee">
      {[0, 1].map((dup) => (
        <div key={dup} className="flex shrink-0">
          {ITEMS.map((item, i) => (
            <span key={`${dup}-${i}`} className="font-display font-bold uppercase tracking-wider text-sm sm:text-base px-6 flex items-center gap-6">
              {item}
              <span className="text-brand-bg/50">◆</span>
            </span>
          ))}
        </div>
      ))}
    </div>
  </div>
);
